<template>
	<div>
		<div style="background-color: #F6F8FE;height: 50px;">
			 <el-button type="text" style="color: #000000;" icon="arrow-left" @click="backBtn">
				 返回
			 </el-button>
		</div>
		<div class="container">
			<div class="addEnterprises">
				<div class="accinfo">
					<p>
						<span class="row-label">数据类型</span>
						<span>{{this.DataType | DataTypeFilter}}</span>
					</p>
					<p>
						<span class="row-label">患者编号</span>
						<span>{{this.Code}}</span>
					</p>
					<p>
						<span class="row-label">患者姓名</span>
						<span>{{this.PersonName}}</span>
					</p>
					<p>
						<span class="row-label">订单日期</span>
						<span>{{this.DateRecord}}</span>
					</p>
					<p>
						<span class="row-label">所属医院</span>
						<span>{{this.Hospital}}</span>
					</p>
					<p>
						<span class="row-label">文件码</span>
						<span>{{this.FileCode}}</span>
					</p>
					<p>
						<span class="row-label">App二维码</span>
						<span></span>
						<div id="qrcode" style="margin-left: 120px;margin-top: -40px;"></div>
					</p>
          <p>
						<span class="row-label">H5连接</span>
						<!-- <span><a :href="'http://3dshow.zhenyuantech.cn/case/'+this.FileCode" target="_blank">http://3dshow.zhenyuantech.cn/case/{{this.FileCode}}</a></span> -->
            <span><a :href="'http://112.125.27.239:3801/#/case/'+this.FileCode" target="_blank">http://112.125.27.239:3801/#/case/{{this.FileCode}}</a></span>
					</p>
          <p>
						<span class="row-label">H5二维码</span>
						<span></span>
						<div id="qrcode1" style="margin-left: 120px; margin-top: -40px;"></div>
					</p>
					<p>
						<span class="row-label">CT文件</span>
						<span>{{this.FileCodeStatus}}</span>
					</p>

					<p>
						<span class="row-label">Dicom</span>
						<span>{{this.FileCodeDcmStatus}}</span>
					</p>
					
				</div>
				
				<div>
					<el-button class="alterBtn" @click="alterBtn">修改</el-button>
				</div>
				
				
				
			</div>
	 
		</div>
	</div>
</template>

<script>
import QRCode from "qrcodejs2"; // 引入qrcode
import { WebFileCode } from "@/api/api";
export default {
  data() {
    return {
      value1: "",
      fileData: {},
      fileList: [],
      rules1: {},
      Code: "",
      DateRecord: "",
      DownUrl: "",
      FileCode: "",
      // FileCode1: "http://3dshow.zhenyuantech.cn/case/" + this.FileCode,
      ModeType: "",
      Hospital: "",
      PersonName: "",
      DataType: "",
      FileCodeStatus: "",
      FileCodeDcmStatus: "",
    };
  },
  // mounted () {
  // 	this.qrcode(this.FileCode);
  // },
  filters: {
    DataTypeFilter(value) {
      // [(0, '肺'), (1, '泌尿'), (2, '神外'), (3, '肝胆'), (4, '心脏')]
      if (value == 0) {
        return "肺";
      } else if (value == 1) {
        return "泌尿";
      } else if (value == 2) {
        return "神外";
      } else if (value == 3) {
        return "肝胆";
      } else if (value == 4) {
        return "心脏";
      } else if (value == 5) {
        return "胰腺";
      } else if (value == 6) {
        return "甲状腺";
      } else if (value == 7) {
        return "耳鼻喉";
      } else if (value == 8) {
        return "食管";
      } else if (value == 9) {
        return "纵膈";
      } else if (value == 10) {
        return "胸外";
      } else if (value == 11) {
        return "普外";
      } else if (value == 12) {
        return "骨科";
      } else if (value == 13) {
        return "乳腺";
      } else if (value == 14) {
        return "妇科";
      } else if (value == 15) {
        return "胃肠";
      } else if (value == 16) {
        return "血管";
      } else if (value == 17) {
        return "腹腔";
      } else if (value == 18) {
        return "盆腔";
      }
    },
  },
  created() {
    console.log("created FileInfo");
    console.log(this.$route.query.fileCode);
    this.FileInfo();
  },
  activated() {},
  methods: {
    //跳转修改页面
    alterBtn: function () {
      this.$router.push({ path: "/alterFile", query: this.fileData });
    },

    qrcode(filecode) {
      let qrcode = new QRCode("qrcode", {
        width: 128,
        height: 128,
        text: filecode, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
    },

    qrcode1(filecode) {
      let qrcode1 = new QRCode("qrcode1", {
        width: 128,
        height: 128,
        text: filecode, // 二维码地址
        colorDark: "#000",
        colorLight: "#fff",
      });
    },

    backBtn() {
      this.$router.push({ path: "/FileList" });
    },
    //获取文件信息
    FileInfo() {
      let data = {};
      data.FileCode = this.$route.query.fileCode;

      console.log("data");
      console.log(data);
      WebFileCode(data).then((res) => {
        this.fileData = res;
        // console.log("res000000000000000000000");
        console.log(res);
        // Code: "BGZ001"
        // DateRecord: "2019-09-03 15:12:11"
        // DownUrl: "http://www.evoka.com.cn/videofile/双侧肺obj.zip"
        // ErrorCode: 0
        // ErrorDes: ""
        // FileCode: "ZY93173818"
        // ModeType: 0
        // PersonName: "张三"
        // ProtocolId: 2002
        this.Code = res.Code;
        this.DateRecord = res.DateRecord;
        this.FileCode = res.FileCode;
        this.PersonName = res.PersonName;
        this.Hospital = res.Hospital;
        this.DataType = res.DataType;
        this.FileCodeStatus = res.FileCodeStatus;
        this.FileCodeDcmStatus = res.CTFileUrlDcm ? "已上传" : "未上传";
        this.qrcode(this.FileCode);
        this.qrcode1("http://112.125.27.239:3801/#/case/" + this.FileCode);
      });
    },
    //tab切换事件
    handleClick(tab, event) {
      // console.log(tab, event);
      //  let flag = event.target.getAttribute("id"); //获取点击的tab标签的id
    },
  },
};
</script>

<style lang="scss" scoped>
.alterBtn {
  margin-top: -20px;
  margin-left: 120px;
  width: 120px;
  height: 40px;
  background: rgba(34, 107, 170, 1);
  border-radius: 4px;
  border: 1px solid rgba(83, 113, 255, 1);

  font-size: 16px;
  font-family: PingFangSC-Regular, PingFangSC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 8px;
}

.marleft {
  margin-left: 70px;
}
.addForm {
  height: 800px;
}
.openaddbtn {
  height: 58px;
  text-align: center;
  background: rgba(248, 248, 248, 1);
  line-height: 58px;
}
.container {
  margin-top: 20px;
  width: 1200px;
  height: auto;
  padding-bottom: 30px;
  background: #ffffff;
}
.el-form-item {
  margin-left: -75px;
  width: 450px;
}
.addEnterprises {
  margin-top: 10px;
  margin-left: 10px;
  // margin-bottom: 130px;
}

.accinfo p span:first-child {
  display: inline-block;
  width: 70px;
  /*text-align-last: justify;*/
  font-size: 16px;
  font-family: PingFangSC-Semibold;
  font-weight: 500;
  line-height: 20px;
  margin-right: 40px;
}
.accinfo p {
  padding: 5px;
}
.accinfo p span:last-child {
  font-size: 16px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.accinfo {
  padding: 20px;
  margin-top: -30px;
}
.row-label {
  font-size: 14px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// FileInfo.vue?faf7bda4